import React from 'react';

/**
 * Per-day platform activity table for Daily active users.
 * Props: { rows, onCellClick }
 *   rows: array of {access_date, android_users, ios_users,
 *                   android_watch_users, ios_watch_users, total_users}
 *   onCellClick(access_date, platformKey, count): optional — when provided,
 *     each nonzero count becomes a drill-down button (feature 053). platformKey
 *     is one of android | ios | android_watch | ios_watch | total.
 */
const n = (v) => Number(v ?? 0);
const fmt = (v) => n(v).toLocaleString();
const asDate = (d) => (d ? String(d).split('-').reverse().join('/') : '-');

// column key -> platformKey passed to onCellClick
const CELLS = [
  { field: 'android_users', platform: 'android', label: 'Android', bold: false },
  { field: 'ios_users', platform: 'ios', label: 'iOS', bold: false },
  { field: 'android_watch_users', platform: 'android_watch', label: 'Android watch', bold: false },
  { field: 'ios_watch_users', platform: 'ios_watch', label: 'iOS watch', bold: false },
  { field: 'total_users', platform: 'total', label: 'Total', bold: true },
];

const CountCell = ({ row, cell, onCellClick }) => {
  const count = n(row[cell.field]);
  const content = cell.bold ? <b>{fmt(count)}</b> : fmt(count);
  const clickable = typeof onCellClick === 'function' && count > 0;

  return (
    <td className="tnum" data-label={cell.label}>
      {clickable ? (
        <button
          type="button"
          className="au-cell-link"
          onClick={() => onCellClick(row.access_date, cell.platform, count)}
          title={`View the ${count.toLocaleString()} ${cell.label} users`}
        >
          {content}
        </button>
      ) : (
        content
      )}
    </td>
  );
};

const DailyActivityTable = ({ rows = [], onCellClick }) => (
  <div className="au-table-wrap">
    <table className="au-table" data-testid="au-daily-table">
      <thead>
        <tr>
          <th>Date (UTC)</th>
          <th>Android</th>
          <th>iOS</th>
          <th>Android watch</th>
          <th>iOS watch</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={r.access_date || i}>
            <td data-label="Date (UTC)">{asDate(r.access_date)}</td>
            {CELLS.map((cell) => (
              <CountCell key={cell.field} row={r} cell={cell} onCellClick={onCellClick} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DailyActivityTable;
